import React from 'react';
import { Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useTheme } from '@mui/material/styles';

import ControlField from './ControlField';
import { getControlTokens } from './controlTokens';

function ControlSearchField({
  value = '',
  onChange,
  placeholder = 'Search',
  ariaLabel = placeholder,
  context = 'filterBar',
  width = 200,
  minWidth,
  maxWidth = '100%',
  sx,
}) {
  const theme = useTheme();
  const tokens = getControlTokens(theme, context);

  return (
    <ControlField
      context={context}
      width={width}
      minWidth={minWidth}
      maxWidth={maxWidth}
      sx={sx}
    >
      <Box
        sx={{
          width: '100%',
          height: tokens.height,
          display: 'flex',
          alignItems: 'center',
          gap: tokens.gap,
          px: 1,
          borderRadius: `${tokens.radius}px`,
          border: `1px solid ${tokens.borderColor}`,
          bgcolor: tokens.surface,
          color: tokens.textColor,
          boxSizing: 'border-box',
          '&:focus-within': {
            borderColor: theme.palette.primary.main,
            boxShadow: `0 0 0 1px ${theme.palette.primary.main}`,
          },
        }}
      >
        <SearchIcon sx={{ color: 'text.disabled', flexShrink: 0, fontSize: 15 }} />
        <Box
          component="input"
          type="search"
          value={value}
          onChange={(event) => onChange?.(event.target.value)}
          placeholder={placeholder}
          aria-label={ariaLabel}
          sx={{
            flex: 1,
            minWidth: 0,
            border: 0,
            outline: 0,
            bgcolor: 'transparent',
            color: 'inherit',
            font: 'inherit',
            fontSize: tokens.fontSize,
            fontWeight: 600,
            lineHeight: 1,
            p: 0,
            '&::placeholder': {
              color: theme.palette.text.disabled,
              opacity: 1,
            },
            '&::-webkit-search-cancel-button': {
              cursor: 'pointer',
            },
          }}
        />
      </Box>
    </ControlField>
  );
}

export default ControlSearchField;
